import React, { useState, useEffect } from 'react';
import {
    Grid,FormControl,InputLabel,OutlinedInput, TextField
  } from '@material-ui/core';
  import DeleteIcon from '@material-ui/icons/Delete';

  const MileStone = props => {
    const {data}=props;

    return(<Grid container direction="row" justify="flex-start" spacing={2}>
      <Grid item xs={4}>
        <TextField
          name='milestoneId'
          variant='outlined'
          label='Milestone Id'
          fullWidth
          value={data.milestoneId}
          onChange={props.onChange}
        />
      </Grid>
      <Grid item xs={8}>
        <TextField
          name='descreption'
          variant='outlined'
          label='Description'
          fullWidth
          value={data.descreption}
          onChange={props.onChange}
        />
      </Grid>
  </Grid>)

  }
  export default MileStone